import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["header", "infoText", "infoBadgeAriaLabel", "children", "gap", "className"];
import { jsxs, jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { TextWithInfoBadge } from '../text-with-info-badge/text-with-info-badge.js';
import styles from './legend.module.js';

function Legend(props) {
  var header = props.header,
      infoText = props.infoText,
      infoBadgeAriaLabel = props.infoBadgeAriaLabel,
      children = props.children,
      _props$gap = props.gap,
      gap = _props$gap === void 0 ? 'default' : _props$gap,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var shouldRenderHeader = header || infoText && infoBadgeAriaLabel;
  return jsxs("fieldset", _objectSpread(_objectSpread({}, rest), {}, {
    className: clsx(styles.fieldset, styles[gap], className),
    children: [shouldRenderHeader ? jsx("legend", {
      className: styles.legend,
      children: jsx(TextWithInfoBadge, {
        className: styles.legendText,
        infoBadgeAriaLabel: infoBadgeAriaLabel,
        infoText: infoText,
        children: header
      })
    }) : null, children]
  }));
}

export { Legend };